import React, { Component } from "react";
import { Message, Loader, Card, Divider } from "semantic-ui-react";
import toast from "react-hot-toast";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import api from "api";
import { SearchParams } from "simplydo/core";

export class LoginWithToken extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, errorMessage: "" };
  }

  componentDidMount() {
    const params = new SearchParams(window.location.search);
    const token = params.get("token");
    const next = params.get("next");
    this.setState({ loading: true });
    api.auth.loginWithToken(
      token,
      () => {
        this.setState({ loading: false });
        this.props.history.push(next || "/");
      },
      (err) => {
        toast.error(err.message);
        this.setState({ loading: false, errorMessage: err.message });
      },
    );
  }

  render() {
    const { loading, errorMessage } = this.state;
    const { t } = this.props;
    return (
      <Card.Group centered>
        <Card raised color="yellow" style={{ marginTop: 50 }}>
          <Card.Content>
            <Card.Header>{t("entry.login.title")}</Card.Header>
            {loading && <Card.Meta>{t("entry.login.token.wait")}</Card.Meta>}
            <Divider hidden />
          </Card.Content>
          <Card.Content textAlign="center">
            {loading && <Loader centered active inline />}
            {errorMessage && (
              <Message color="orange">
                {t("entry.login.token.failed")} {errorMessage}
              </Message>
            )}
          </Card.Content>
        </Card>
      </Card.Group>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });

const LoginWithTokenContainer = connect(mapStateToProps)(LoginWithToken);

export default withTranslation()(LoginWithTokenContainer);
